import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Pro from "../../../Assets/Images/no-image.png";
import Navigation from "./Navigation";
import SmallSideMenu from "./SmallSideMenu";
import axios from "axios";
import { RightModule } from "./RightModule";
import OnlineSmall from "../Sidebar/Left/StarsOnline/OnlineSmall";
import OfflineUserSmall from "../Sidebar/Left/StarsOnline/OfflineUserSmall";
import { serverInfo } from "../../../App";

const Menu = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  const [userInfo, setUserInfo] = useState({});
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [starList, setStarList] = useState([]);
  const [totalNotification, setTotalNotification] = useState();
  const [fanGroup, setFanUserGroup] = useState([]);

  useEffect(() => {
    getUserInformation();
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user/total_notification_count`).then((res) => {
        if (res.data.status === 200) {
          setTotalNotification(res.data.totalNotification);
        }
      });

    localStorage.getItem("auth_token") &&
      axios.get(`/api/user/fan/group/list`).then((res) => {
        if (res.data.status === 200) {
          setFanUserGroup(res.data.useFanGroup);
        }
      });

    axios.get(`/api/user/star_list`).then((res) => {
      if (res.data.status === 200) {
        setStarList(res.data.stars);
      }
    });
  }, []);

  const onlineUserArr = onlineUsers.map((item) => parseInt(item.userId));
  // const set = new Set(onlineUserArr);

  const allStarArr = starList.filter(({ id }) => !(onlineUserArr?.includes(id)));

  let getUserInformation = () => {
    localStorage.getItem("auth_token") &&
      axios.get(`api/user_info`).then((res) => {
        if (res.data.status === 200) {
          setUserInfo(res.data.users);
        }
      });
  };
  return (
    <>
      <Navigation />

      <div className="MenuBgColo bg-dark py-3">
        <div className="d-flex justify-content-between mb-3">
          <h3 className="text-light mx-3">Menu</h3>
          <i
            class="fa-solid fa-arrow-left-long text-light mx-4 pt-1"
            onClick={goBack}
          ></i>
        </div>

        <Link to="/profile">
          <div className="d-flex align-items-center mx-2 mb-2  ">
            <div className="ms-2">
              <img
                src={
                  userInfo?.image != null ? imageCdnUrl + userInfo?.image : Pro
                }
                alt=""
                className="star-img-online"
              />
            </div>

            <div className="mx-3">
              <div className="text-light star-name-im fw-bold">
                {userInfo?.first_name} {userInfo?.last_name}
              </div>
              <small className="SeePo">See profile</small>
            </div>
          </div>
        </Link>

        <div className="divUl "></div>

        {/* Star Online */}
        <div className="d-flex align-items-center my-3 TabStarOn">
          <div className="col-md-2">
            <div className="card fw-bold mt-2 px-2 mx-2 StarOl">
              Star Online
            </div>
          </div>
          <div className="d-flex StarKs">
            {onlineUsers.map((u) => (
              <div className="StaPo mx-2">
                <OnlineSmall key={u.userId} user={u.userId} />
              </div>
            ))}

            {allStarArr &&
              allStarArr?.map((u) => (
                <>
                  <div className="StaPo mx-2">
                    <OfflineUserSmall key={u.id} user={u} />{" "}
                  </div>
                </>
              ))}
          </div>
        </div>
        {/* Star Online End*/}

        <div className="divUl "></div>

        {/* Left Side */}
        <div className="d-flex flex-wrap  my-3 ">
          <SmallSideMenu />
        </div>
        <div className="divUl "></div>

        {/* Right Side  */}
        <RightModule />
      </div>
    </>
  );
};

export default Menu;
